import React from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";
import "../styles/termsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container theme--2">
      <header className="terms-header">
        <h1>Terms & Conditions</h1>
        <p>Welcome to Savannah Shine Hub</p>
      </header>

      <section className="terms-section">
        <h2>1. Introduction</h2>
        <p>
          1.1 This website (<strong>https://savannahshinehub.com</strong>) and related services are owned and operated by{" "}
          <strong>Savannah Shine Hub</strong> (“we”, “our”, “us”).
        </p>
        <p>
          1.2 These Terms and Conditions govern your use of our website and services, including car wash,
          carpet cleaning, and water refill delivery (“Services”).
        </p>
        <p>
          1.3 By accessing or using our website or booking our services, you agree to comply with these Terms.
          If you do not agree, please do not use our services.
        </p>
        <p>
          1.4 Your personal data is handled in accordance with Kenya’s Data Protection Act. Please review our{" "}
          <a href="/privacy-policy" className="terms-link">
            Privacy Policy
          </a>.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Services</h2>
        <p>
          Savannah Shine Hub provides on-demand and scheduled services including:
        </p>
        <ul>
          <li>Mobile car wash services</li>
          <li>Carpet cleaning and pickup</li>
          <li>Water refill and delivery</li>
        </ul>
        <p>
          Service availability may vary depending on location and operational capacity.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. Bookings & Payments</h2>
        <p>
          3.1 All bookings must include accurate customer and location details.
        </p>
        <p>
          3.2 Prices are displayed on the website and may vary depending on service type,
          quantity, and location.
        </p>
        <p>
          3.3 We reserve the right to adjust pricing in case of incorrect listings or special requests.
        </p>
        <p>
          3.4 Payment may be made via approved methods communicated during booking or delivery.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Cancellations & Rescheduling</h2>
        <p>
          4.1 Customers may cancel or reschedule bookings by contacting us before the scheduled time.
        </p>
        <p>
          4.2 Late cancellations may result in delays or additional charges depending on the situation.
        </p>
      </section>

      <section className="terms-section">
        <h2>5. Customer Responsibilities</h2>
        <ul>
          <li>Provide accurate delivery or service location</li>
          <li>Ensure access to the premises at the scheduled time</li>
          <li>Provide a safe working environment for our staff</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>6. Liability</h2>
        <p>
          While we strive to provide high-quality services, Savannah Shine Hub is not liable for:
        </p>
        <ul>
          <li>Delays caused by traffic, weather, or unforeseen circumstances</li>
          <li>Pre-existing damage to carpets, vehicles, or containers</li>
          <li>Service interruptions beyond our control</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>7. Intellectual Property</h2>
        <p>
          All content on this website, including text, images, branding, and design,
          is the property of <strong>Savannah Shine Hub</strong> and may not be copied
          or reused without permission.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. Changes to Terms</h2>
        <p>
          We may update these Terms at any time. Continued use of our services
          indicates acceptance of the updated Terms.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. Governing Law</h2>
        <p>
          These Terms are governed by the laws of Kenya. Any disputes will be handled
          within Kenyan jurisdiction.
        </p>
      </section>

      <section className="terms-section">
        <h2>10. Contact Us</h2>
        <div className="contact-links">
          <p>
            <MdPhone className="contact-icon" /> +254 XXX XXX XXX
          </p>
          <p>
            <MdEmail className="contact-icon" />{" "}
            <a href="mailto:savannahshinehub@gmail.com">
              savannahshinehub@gmail.com
            </a>
          </p>
          <p>
            <FaGlobe className="contact-icon" />{" "}
            <a
              href="https://savannahshinehub.com"
              target="_blank"
              rel="noreferrer"
            >
              www.savannahshinehub.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;